import {Button} from '@hm/fundamental'
import {Box, CircularProgress} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {Order} from '../../../../../Pages/Order/Order.types'
import {ManageOrderButtonVariant} from '../../hooks/useManageOrderButtonVisibility'

interface ManageOrderButtonProps {
  order: Order
  onClick?: () => void
  variant: ManageOrderButtonVariant
  isLoading?: boolean
  disabled?: boolean
}

export const ManageOrderButton: React.FC<ManageOrderButtonProps> = ({
  order,
  onClick,
  variant,
  isLoading = false,
  disabled = false
}) => {
  const {t} = useTranslation()

  const isConfirmVariant = variant === 'manageAndConfirm'
  const buttonVariant = isConfirmVariant ? 'primary' : 'secondary'
  const translationKey = isConfirmVariant
    ? 'order.orderDetails.orderManagement.manageAndConfirmOrder'
    : 'order.orderDetails.orderManagement.manageOrder'

  const loadingSpinner = <CircularProgress size={20} color="inherit" />

  return (
    <Box width={1}>
      <Button
        variant={buttonVariant}
        size="large"
        onClick={onClick}
        data-test-id={`manage-order-button-${order.orderId}`}
        className="w-full"
        disabled={isLoading || disabled}
        icon={isLoading ? loadingSpinner : undefined}
      >
        {t(translationKey)}
      </Button>
    </Box>
  )
}
